/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="controls.module.ts" />

module Meevo.Components.Controls {
    "use strict";

    export class MeevoSecuritySelect implements angular.IDirective {
        restrict = "E";
        require = "ngModel";
        scope = {
            currentValue: "=ngModel",
            callBack: "&ngChange",
            disabled: "=ngDisabled",
            parentKey: "=parentPermission"
        };

        templateUrl = "app/components/controls/securitySelectTemplate.html";

        link = (scope: any, element: JQuery, attrs: angular.IAttributes) => {
            scope.dropdown = false;

            scope.GRANT = Model.SecurityAccessEnum.Grant;
            scope.DENY = Model.SecurityAccessEnum.Deny;
            scope.HIDE = Model.SecurityAccessEnum.Hide;
            
            scope.backgroundColor = () => {
                if (scope.currentValue == scope.GRANT) return "#59b528"; // Grant
                if (scope.currentValue == scope.HIDE) return "#4c4c4c"; // Hide
                if (scope.currentValue == scope.DENY) return "#cf2441"; // Deny
            }

            scope.displayName = () => {
                if (scope.currentValue == scope.GRANT) return "GRANT"; // Grant
                if (scope.currentValue == scope.HIDE) return "HIDE"; // Hide
                if (scope.currentValue == scope.DENY) return "DENY"; // Deny
            }

            scope.assign = (permission: string) => {
                if (scope.currentValue === permission) {
                    return;
                }
                scope.currentValue = permission;
                scope.dropdown = false;
                setTimeout(() => {
                    scope.callBack();
                });
            }

            scope.openDropdown = () => {
                scope.dropdown = !scope.dropdown;
            }

            scope.showGrant = () => {
                return scope.parentKey === undefined || scope.parentKey === scope.GRANT;
            }

            scope.showDeny = () => {
                return scope.parentKey === undefined || scope.parentKey === scope.GRANT || scope.parentKey === scope.DENY;
            }
        }
        constructor() {
        }
        static factory(): angular.IDirectiveFactory {
            let directive = () => {
                return new MeevoSecuritySelect();
            };
            directive.$inject = [];
            return directive;
        }
    }

    angular.module("meevo.components.controls")
        .directive("meevoSecuritySelect", MeevoSecuritySelect.factory());
}